import React, { useEffect } from 'react';

import Footer from '../../pages/homepage/components/Footer';
import Header from '../../components/ui/Header';
import { Helmet } from 'react-helmet';
import HeroSection from './components/HeroSection';
import MissionValuesSection from './components/MissionValuesSection';
import MissionVisionSection from './components/MissionVisionSection';
import PhilosophySection from './components/PhilosophySection';

const About = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<>
			<Helmet>
				<title>About Us - Fepa Law Partners | Excellence in Legal Advocacy</title>
				<meta
					name='description'
					content="Discover Fepa Law Partners' experienced team of attorneys and solicitors. Learn about our comprehensive practice areas and commitment to delivering cost-effective legal solutions in Nigeria."
				/>
				<meta
					name='keywords'
					content='about Fepa Law Partners, Nigerian law firm, legal excellence, commercial law, debt recovery, intellectual property, energy law'
				/>
				<meta
					property='og:title'
					content='About Us - Fepa Law Partners | Excellence in Legal Advocacy'
				/>
				<meta
					property='og:description'
					content="Discover Fepa Law Partners' experienced team and comprehensive legal services in Nigeria."
				/>
				<meta property='og:type' content='website' />
				<link rel='canonical' href='/about' />
			</Helmet>

			<div className='min-h-screen bg-background'>
				<Header />

				<main className='pt-16'>
					<HeroSection />
					<PhilosophySection />
					<MissionVisionSection />
					<MissionValuesSection />
				</main>

				<Footer />
			</div>
		</>
	);
};

export default About;
